import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface AnswerTypeRulesInterface {
    deleteModalVisible: boolean,
    deleteId?: string,
}

function getInitialState(): AnswerTypeRulesInterface {
    return {
        deleteModalVisible: false,
    }
}

export const AnswerTypeRulesSlice = createSlice({
    name: "AnswerTypeRulesSlice",
    initialState: getInitialState(),
    reducers: {
        reset: () => getInitialState(),
        changeDeleteModalVisible: (state: AnswerTypeRulesInterface, action: PayloadAction<boolean>) => {
            state.deleteModalVisible = action.payload
        },
        changeDeleteId: (state: AnswerTypeRulesInterface, action: PayloadAction<string | undefined>) => {
            state.deleteId = action.payload
        },
    },
});

export const {reset, changeDeleteId, changeDeleteModalVisible} = AnswerTypeRulesSlice.actions;

export const AnswerTypeRulesSelectors = {
    deleteModalVisible: (state: RootState) => state.answerTypeRules.deleteModalVisible,
    deleteId: (state: RootState) => state.answerTypeRules.deleteId,
}

export const AnswerTypeRulesReducer = AnswerTypeRulesSlice.reducer;
